import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    badWork: {
        color: `${theme.point.labelWarning} !important`,
    },
    badWorkEdited: {
        color: `${theme.point.editLabelWarning} !important`,
    },
    disabledTextFieldStyle: {
        textAlign: 'left',
        color: theme.textField.disabledTextColor,
    },
    editedField: {
        color: theme.textField.textColor,
    },
    field: {
        flex: '0 1 19%',
        marginTop: 6,
        marginBottom: theme.spacing(2),
        ['@media (max-width:440px)']: {
            flex: '1 1 50%',
        },
    },
    helperText: {
        position: 'absolute',
        top: '54px',
        fontSize: '14px',
        lineHeight: '14px',
    },
    hidden: {
        visibility: 'hidden !important',
    },
    label: {
        whiteSpace: 'nowrap',
    },
    wellDone: {
        color: `${theme.point.labelGreen} !important`,
    },
    wellDoneEdited: {
        color: `${theme.point.editLabelGreen} !important`,
    },
}));
